<template>
  <div :class="$style.inputWrapper">
    <b-form-group
      v-if="showLabel"
      :id="`${label}-${name}`"
      :label-for="name"
      :label="label"
      :label-class="$style.inputLabel"
    >
      <b-form-input
        v-if="mask"
        :id="name"
        v-mask="mask"
        :class="$style.inputField"
        :value="syncData"
        :type="type"
        :name="name"
        :disabled="disabled"
        :placeholder="label"
        @input="change"
      />
      <b-form-input
        v-else
        :id="name"
        :class="$style.inputField"
        :value="syncData"
        :type="type"
        :name="name"
        :disabled="disabled"
        :placeholder="label"
        @input="change"
      />
    </b-form-group>
    <b-form-group
      v-else
      :id="`${label}-${name}`"
      :label-for="name"
      :label-class="$style.inputLabel"
    >
      <!-- <slot name="label">{{label}}</slot> -->
      <floater>
        <b-form-input
          v-if="mask"
          :id="name"
          v-mask="mask"
          :class="$style.inputField"
          :value="syncData"
          :type="type"
          :name="name"
          :disabled="disabled"
          :placeholder="label"
          @input="change"
        />
        <b-form-input
          v-else
          :id="name"
          :class="$style.inputField"
          :value="syncData"
          :type="type"
          :name="name"
          :disabled="disabled"
          :placeholder="label"
          @input="change"
        />
      </floater>
    </b-form-group>
    <div
      v-show="submitted"
      :class="$style.inputError"
    >
      {{ error }}
    </div>
  </div>
</template>

<script>
import AwesomeMask from 'awesome-mask'
import { getValidityForRule } from '@utils/form-helpers'
import { mapActions, mapGetters } from 'vuex'

export default {
  directives: {
    mask: AwesomeMask,
  },

  props: {
    disabled: { required: false, type: Boolean, default: false },
    form: { required: true, type: String },
    label: { required: true, type: String },
    mask: { required: false, type: null, default: null },
    name: { required: true, type: String },
    rules: { required: true, type: Array }, // Format [{ rule: String, message: String }]
    secondaryValue: { required: false, type: null, default: null },
    showLabel: { required: false, type: Boolean, default: false },
    submitted: { required: true, type: Boolean },
    type: { required: true, type: String },
  },

  computed: {
    ...mapGetters({
      primaryField: 'customers/getPrimaryCustomerFormField',
      secondaryField: 'customers/getSecondaryCustomerFormField',
      deliveryField: 'customers/getDeliveryFormField',
      paymentField: 'customers/getPaymentFormField',
      shippingField: 'customers/getShippingFormField',
    }),
    syncData() {
      let value
      if (this.form === 'primary') {
        value = this.primaryField(this.name)
        if (!value) {
          value = ''
        }
      } else if (this.form === 'secondary') {
        value = this.secondaryField(this.name)
      } else if (this.form === 'delivery') {
        value = this.deliveryField(this.name)
      } else if (this.form === 'payment') {
        value = this.paymentField(this.name)
      } else if (this.form === 'shipping') {
        value = this.shippingField(this.name)
      }
      return value
    },
    error() {
      for (let i = 0; i < this.rules.length; i += 1) {
        if (
          !getValidityForRule(
            this.rules[i].rule,
            this.syncData,
            this.secondaryValue
          )
        ) {
          return this.rules[i].message
        }
      }
      return ''
    },
  },

  methods: {
    ...mapActions({
      updatePrimaryField: 'customers/updatePrimaryField',
      updateSecondaryField: 'customers/updateSecondaryField',
      updateDeliveryField: 'customers/updateDeliveryField',
      updatePaymentField: 'customers/updatePaymentField',
      updateShippingField: 'customers/updateShippingField',
    }),
    setField(field, value) {
      if (this.form === 'primary') {
        this.updatePrimaryField({ field, value })
      } else if (this.form === 'secondary') {
        this.updateSecondaryField({ field, value })
      } else if (this.form === 'delivery') {
        this.updateDeliveryField({ field, value })
      } else if (this.form === 'payment') {
        this.updatePaymentField({ field, value })
      } else if (this.form === 'shipping') {
        this.updateShippingField({ field, value })
      }
    },
    change(value) {
      const data = value
      this.setField(this.name, data)
      this.$emit('input', value)
    },
  },
}
</script>

<style lang="scss">
@import '@design';

/* stylelint-disable selector-max-type */
.vfl-label-on-input {
  top: -1.6em !important;
  right: unset !important;
}
.vfl-has-label {
  padding: 0 0 7px 0;
}
.vfl-label + input {
  padding-left: 5px;
  font-size: 1.125rem;
  border: 0;
  border-bottom: 1px solid #ccc;
  transition: border 0.2s;
}

.vfl-label-on-focus + input {
  border-bottom: 1px solid var(--brandColor);
}
/* stylelint-enable selector-max-type */

.vfl-label-on-focus {
  color: var(--brandColor) !important;
}
.form-control:focus {
  border-bottom: 1px solid var(--brandColor) !important;
}
</style>

<style lang="scss" module>
@import '@design';

.inputField {
  width: 100%;
  // padding: 20px 10px;
  margin-top: 1em;
  font-weight: 700;
  color: #595f6e;
  background: transparent;
  border-radius: 0;
}
.inputField::-webkit-input-placeholder {
  font-size: 0.875rem;
  font-weight: 500;
  color: #999;
}
.inputField::-moz-placeholder {
  font-size: 0.875rem;
  font-weight: 500;
  color: #999;
}
.inputField:-ms-input-placeholder {
  font-size: 0.875rem;
  font-weight: 500;
  color: #999;
}
.inputField:-moz-placeholder {
  font-size: 0.875rem;
  font-weight: 500;
  color: #999;
}
.inputError {
  position: relative;
  top: -15px;
  font-size: 0.8125rem;
  font-style: italic;
  color: #dc3545;
}
.inputWrapper {
  margin: 0 0 1.25rem 0;
}
.requiredInput {
  color: #dc3545;
}
.inputLabel {
  margin-bottom: -0.5rem;
}
</style>
